import * as React from "react"

export default function CalendarOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.334 2H14a.667.667 0 01.667.667v10.666A.667.667 0 0114 14H2a.667.667 0 01-.667-.667V2.667A.667.667 0 012 2h2.667V.667H6V2h4V.667h1.334V2zM10 3.333H6v1.333H4.667V3.333h-2V6h10.666V3.333h-2v1.333H10V3.333zm3.334 4H2.667v5.333h10.667V7.333z"
        fill={props.fill}
      />
    </svg>
  )
}


